<template>
  <div class="position-relative">
    <div class="fixed-top shadow-sm bg-white">
      <div class="container-fluid pr-3">
        <div class="row py-1 justify-content-between align-items-center">
          <div class="col-6 col-md-4 py-2">
            <a href="javascript:" class="d-flex align-items-center text-dark text-decoration-none" @click="goHome()">
              <span class="position-relative">
                <img src="../../assets/logo-lecard.png" alt="Logo LeCard" style="width: 32px" id="imgEmpresa">
                <span class="badge badge-dark badge-env" v-if="is_beta">BETA</span>
                <span class="badge badge-success badge-env" v-else-if="is_homolog">DEV</span>
              </span>
              <h6 class="pl-2 text-ellipsis mb-0" style="font-size: 90%">{{dados.nome_fantasia}} <i class="fa fa-angle-down ml-1 text-primary" v-if="empresas.length > 1"></i></h6>
            </a>
          </div>
          <div class="col-md-8 d-none d-md-flex justify-content-end align-items-center" v-if="showPedidos">
            <button :class="printsError ? 'animated bounceIn infinite btn-secondary' : 'btn-light border-dark'" class="btn border btn-topbar"
                    @click="$store.state.modalFilaPrint = true" title="Pedidos em sua fila de impressão" v-if="!load">
              <img src="../../assets/icons/printer-light.svg" style="width: 20px; margin-top: -5px" v-if="printsError">
              <img src="../../assets/icons/printer.svg" style="width: 20px; margin-top: -5px" v-else>
              <b class="ml-2" v-if="printsError">{{printsError}}</b>
            </button>
            <button v-if="!load && dados.status_fidelidade === '1' && showPedidos" class="btn btn-warning btn-topbar" title="Programa de Vantagens" @click="$emit('openModalFidelidade')">
              <img src="../../assets/icons/vantagens.svg" style="width: 20px; margin-top: -5px">
            </button>
            <button v-if="!load" :disabled="load" class="btn btn-third btn-topbar" title="Taxa e tempo" @click="openTempo()">
              <img src="../../assets/icons/time.svg" style="width: 20px; margin-top: -5px">
            </button>
            <button class="btn btn-topbar" :class="empresa.ativo === '1' ? 'btn-primary' : 'btn-success'" @click="openModalPausa()" :disabled="load" v-if="!load" :title="empresa.ativo === '1' ? 'Fechar agora' : 'Ativar Loja'">
              <img src="../../assets/icons/pause.svg" class="d-lg-none" style="width: 16px; margin-top: -5px" v-if="empresa.ativo === '1'">
              <img src="../../assets/icons/play.svg" class="d-lg-none" style="width: 16px; margin-top: -5px" v-else>
              <span class="d-none d-lg-block">{{empresa.ativo === '1' ? 'Fechar agora' : 'Ativar Loja'}}</span>
            </button>
            <button class="btn btn-light border-dark btn-topbar" title="Notificações" @click="$refs.modalNotificacoes.openModal(true)">
              <img src="../../assets/icons/bell.svg" style="width: 20px; margin-top: -5px">
              <span class="badge-notification bg-secondary" v-if="novidades">{{ novidades }}</span>
            </button>
            <div class="border rounded px-2 overflow-hidden pointer" @click="toggleMenuLojas()" tabindex="1" @blur="modalStatus = false">
              <div class="d-flex justify-content-center align-items-center" v-if="load" style="width: 214px; height: 50px;">
                <div class="animated flipInY infinite" v-if="load">
                  <img src="../../assets/logo-lecard.png" style="width: 32px">
                </div>
              </div>
              <div class="d-flex align-items-center" v-else>
                <div class="d-flex align-items-center" style="width: 200px; height: 50px;">
                  <div>
                    <img :src="dados.url_imagem" class="logo-empresa" v-if="dados.url_imagem">
                    <img src="../../assets/logo-lecard.png" class="logo-empresa" v-else>
                  </div>
                  <div v-if="!connected">
                    <h6 class="m-0 font-weight-bold text-danger">Desconectado</h6>
                    <div class="small text-nowrap">Verifique sua internet</div>
                  </div>
                  <div v-else>
                    <h6 class="m-0 font-weight-bold text-success">Conectado</h6>
                    <div class="small text-nowrap">Visualizar status</div>
                  </div>
                </div>
                <div class="ml-auto text-dark pr-1">
                  <i class="fa" :class="modalStatus ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 py-2 text-right d-md-none text-nowrap">
            <button class="btn btn-light border-dark position-relative mr-2" title="Notificações" @click="$refs.modalNotificacoes.openModal(true)">
              <img src="../../assets/icons/bell.svg" style="width: 22px; display: block">
              <span class="badge-notification bg-secondary" v-if="novidades" style="top: -8px">{{ novidades }}</span>
            </button>
            <button class="btn btn-light border-dark" @click="menu = !menu">
              <img src="../../assets/icons/square.svg" style="width: 22px; display: block">
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-lateral" :class="{'opened': menu}" @click="menu = false" v-if="dados.id_funcao <= 2">
      <div class="menu-body">
        <div class="mb-2" v-if="showPedidos">
          <router-link to="/pedidos" active-class="btn--active" class="btn btn-block position-relative btn-menu">
            <img src="../../assets/icons/orders.svg" alt="">
            <span>Pedidos</span>
            <span class="badge-notification bg-primary" v-if="bell.status">{{ bell.orders }}</span>
          </router-link>
        </div>
        <a v-if="isTerminal" :class="{'btn--active': $route.path.startsWith('/home')}" class="btn btn-block btn-menu" href="javascript:" @click="goTerminal()">
          <img alt="Scale" src="../../assets/icons/scale.svg">
          <span>Terminal</span>
        </a>
        <a v-else :class="{'btn--active': $route.path.startsWith('/home')}" class="btn btn-block btn-menu" href="javascript:" @click="goPdv()">
          <img alt="PDV" src="../../assets/icons/pos.svg">
          <span>PDV</span>
        </a>
        <router-link to="/cardapio" class="btn btn-block btn-menu" active-class="btn--active" v-if="!isReadOnly">
          <img src="../../assets/icons/food-menu.svg" alt="">
          <span>Cardápio</span>
        </router-link>
        <a v-if="!isReadOnly && dados.chat_lecard === '1'" class="btn btn-block btn-menu position-relative" href="javascript:" @click="openChats">
          <img src="../../assets/icons/suport.svg" alt="Chat">
          <span>Chat</span>
          <span class="badge-notification bg-primary" v-if="chats.length">{{ chats.length }}</span>
        </a>
        <router-link to="/ajuda" class="btn btn-block btn-menu" title="Central de Ajuda" active-class="btn--active" v-if="!isReadOnly">
          <img src="../../assets/icons/information.svg" alt="Chat">
          <span>Ajuda</span>
        </router-link>

        <button v-if="!load && showPedidos" :disabled="load" class="btn btn-block btn-menu d-md-none" @click="openTempo()">
          <img src="../../assets/icons/time.svg" alt="">
          <span>Taxa e Tempo</span>
        </button>

        <button v-if="!load && dados.status_fidelidade === '1' && showPedidos" class="btn btn-block btn-menu d-md-none" title="Programa de Vantagens" @click="$emit('openModalFidelidade')">
          <img src="../../assets/icons/vantagens.svg" alt="">
          <span>Fidelidade</span>
        </button>

        <button v-if="showPedidos" :disabled="load" class="btn btn-primary btn-block justify-content-center d-md-none mt-3 mb-2" @click="reloadPage()">
          <i class="fa fa-sync-alt mr-2"></i> Sincronizar
        </button>

        <button v-if="!load && showPedidos" :class="empresa.ativo === '1' ? 'btn-secondary' : 'btn-dark'" :disabled="load" class="btn btn-block justify-content-center d-md-none mb-2" @click="openModalPausa()">
          {{empresa.ativo === '1' ? 'Fechar agora' : 'Ativar Loja'}}
        </button>

        <div class="menu-bottom" v-if="!isReadOnly">
          <a href="javascript:" class="btn btn-block btn-menu" @click="goPortal()" :class="{'btn--active': $route.path.startsWith('/portal')}">
            <img src="../../assets/icons/report.svg" alt="">
            <span>Portal</span>
          </a>
          <router-link to="/config" active-class="btn--active" class="btn btn-block btn-menu">
            <img src="../../assets/icons/settings.svg" alt="">
            <span>Configs</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="financeiro alert" :class="financeiro.status === 2 ? 'alert-danger' : 'alert-success'" v-if="!hideFinanceiro">
      <div>
        <div class="d-inline mr-1" v-if="financeiro.status === 2">
          <i class="fa fa-exclamation-triangle mr-1"></i>
          Ainda não recebemos o valor da sua assinatura, sua conta será bloqueada em <b class="text-nowrap" v-if="financeiro.dias_vencimento > 1">{{ financeiro.dias_vencimento }} dias</b><b class="text-nowrap" v-else>1 dia</b>.
        </div>
        <div class="d-inline mr-1" v-else>
          Sua assinatura já está disponível para pagamento.
        </div>
        <a :class="financeiro.status === 2 ? 'btn-secondary' : 'btn-success'" :href="financeiro.url_pagamento || 'https://wa.me/5516988156773?text=Poderia me enviar o boleto do LeCard?'" class="btn btn-sm text-nowrap" target="_blank" @click="fecharFinanceiro()">
          Efetuar pagamento
        </a>
      </div>
      <button class="btn text-dark btn-financeiro" @click="fecharFinanceiro()"><i class="fa fa-times"></i></button>
    </div>

    <modal :opened="modalOflline" v-if="showPedidos && !is_mobile">
      <h5 class="text-center">Atenção!</h5>
      <div>Seus pedidos não estão sendo sincronizados. Por favor verifique sua conexão com a internet!</div>
      <div class="text-center mt-3">
        <button class="btn btn-secondary" @click="reloadPage()">Recarregar sistema</button>
        <div class="mt-2">
          <button class="btn text-primary" @click="$store.state.modalOflline = false">Ignorar</button>
        </div>
      </div>
    </modal>

    <modal :opened="modalTempo" no-pad="true">
      <div class="height-100 container-fluid py-3">
        <div class="row justify-content-end">
          <div class="col-md-6" v-if="multiple">
            <div class="mb-3">
              <select class="form-control bg-light" id="empresaTempo" v-model="id_empresa" @change="openTempo()">
                <option :value="e.id_empresa" v-for="e in empresas">{{e.nome_fantasia}}</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="!loadTempo">
          <div class="card border">
            <div class="card-body p-2">
              <div class="row no-gutters align-items-end">
                <div class="col-6 col-md-4">
                  <label class="m-0 font-weight-bold small" for="tempoRetirada">Entregas</label>
                  <div>
                    <div class="d-inline-block pointer" @click="toogleOperacao(true)">
                      <span class="pr-2 small" :class="entrega.tipo_delivery !== '2' ? 'text-success' : 'text-secondary'">{{entrega.tipo_delivery !== '2' ? 'Habilitado' : 'Desativado'}}</span>
                      <img class="switch" src="../../assets/icons/switch-on.svg" v-show="entrega.tipo_delivery !== '2'">
                      <img class="switch" src="../../assets/icons/switch-off.svg" v-show="entrega.tipo_delivery === '2'">
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-4">
                  <label class="m-0 font-weight-bold small" for="tempoRetirada">Retiradas</label>
                  <div>
                    <div class="d-inline-block pointer" @click="toogleOperacao(false)">
                      <span class="pr-2 small" :class="entrega.tipo_delivery <= 2 ? 'text-success' : 'text-secondary'">{{entrega.tipo_delivery <= 2 ? 'Habilitado' : 'Desativado'}}</span>
                      <img class="switch" src="../../assets/icons/switch-on.svg" v-show="entrega.tipo_delivery <= 2">
                      <img class="switch" src="../../assets/icons/switch-off.svg" v-show="entrega.tipo_delivery === '3'">
                    </div>
                  </div>
                </div>
                <div class="col-md-4" :class="{'invisible': entrega.tipo_delivery > 2}">
                  <div>
                    <label class="m-0 font-weight-bold small" for="tempoRetirada">Retirada ({{ tempo }})</label>
                    <input type="number" id="tempoRetirada" min="0" max="300" class="form-control m-0" v-model="entrega.media_retirada">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="entrega.tipo_delivery !== '2'" v-if="entrega">
            <hr>
            <div class="text-center" v-if="entrega.geo_disabled !== '2'">
              <div class="row no-gutters pb-2 border-bottom small font-weight-bold d-none d-md-flex">
                <div class="col-3 col-md-4 text-left">Alcance</div>
                <div class="col-5 col-md-4">Taxa</div>
                <div class="col-4 col-md-4">Tempo ({{ tempo }})</div>
              </div>
              <div class="row no-gutters align-items-center py-2 border-bottom" v-for="(e, index) in entrega.raios" :key="index">
                <div class="col-3 col-md-4 small pr-2 text-left" v-if="entrega.geo_disabled === '1'">Entrega única</div>
                <div class="col-3 col-md-4 small pr-2 text-left" v-else>Até {{e.raio_entrega / 1000}} km</div>
                <div class="col-5 col-md-4 pr-2"><money class="form-control" v-model="e.taxa_entrega"/></div>
                <div class="col-4 col-md-4 pr-1">
                  <input type="number" min="0" max="300" class="form-control" v-model="e.tempo_entrega">
                </div>
              </div>
            </div>
            <div v-else-if="entrega.zonas">
              <div class="row no-gutters align-items-end mb-2">
                <div class="col-md-4 pr-md-2 mb-2">
                  <label class="m-0 font-weight-bold small">+ Valor</label>
                  <money class="form-control" v-model="zona_taxa"/>
                </div>
                <div class="col-md-4 pr-md-2 mb-2">
                  <label class="m-0 font-weight-bold small">+ Tempo ({{ tempo }})</label>
                  <input type="number" max="300" class="form-control m-0" v-model="zona_tempo">
                </div>
                <div class="col-md-4 mb-2">
                  <button class="btn btn-primary btn-block" @click="alterarZona()"><i class="fa fa-plus"></i> Alterar</button>
                </div>
              </div>
              <div class="alert alert-info small">
                Ajuste o tempo e o valor da taxa de entrega. Insira um valor positivo para adicionar ou negativo para subtrair. Clique em 'Alterar' para aplicar a todos.
              </div>
              <div class="text-center">
                <div class="row no-gutters pb-2 border-bottom small font-weight-bold d-none d-md-flex">
                  <div class="col-6 text-left">Área</div>
                  <div class="col-3">Taxa</div>
                  <div class="col-3">Tempo ({{ tempo }})</div>
                </div>
                <div class="row no-gutters align-items-center py-2 border-bottom" v-for="(e, index) in entrega.zonas" :key="index">
                  <div class="col-6 small text-left">{{e.nome_zona}}</div>
                  <div class="col-3">{{e.taxa_entrega | valor}}</div>
                  <div class="col-3">{{e.tempo_entrega}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" style="padding: 128px 0" v-else>
          <div class="animated flipInY infinite">
            <img src="../../assets/logo-lecard.png" alt="" style="width: 48px">
          </div>
          <div class="mt-2">Por favor aguarde..</div>
        </div>
      </div>
      <div class="border-top p-2 text-center d-flex justify-content-between">
        <button class="btn btn-dark border p-3" @click="modalTempo = false"><i class="fa fa-angle-left mr-1"></i> Voltar</button>
        <div>
          <button class="btn btn-primary px-4 py-3" @click="salvarTempo()">Salvar</button>
        </div>
      </div>
    </modal>

    <modal :opened="modalPausa" no-pad="true">
      <div class="container-fluid py-3">
        <h5 class="font-weight-bold text-center text-dark" style="margin-bottom: 12px">Fechar Loja</h5>
        <div class="mb-3">
          <div class="alert alert-warning small mb-0 mt-2" v-if="dadosPausa.tempo === 1440">
            <i class="fa fa-exclamation-triangle mr-1"></i> Sua loja ficará desativada até o próximo expediente
          </div>
          <div class="alert alert-info small mb-2 mt-2" v-else>
            <i class="fa fa-info-circle mr-1"></i> Sua loja ficará fechada pelo tempo informado e será aberta de forma automática quando este período acabar.
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-for="p in pausas">
            <label class="d-flex align-items-center mb-1">
              <input type="radio" name="minutosPausa" :value="p.valor" v-model="dadosPausa.tempo" class="mr-2" @change="togglePausa">
              <span>{{ p.nome }}</span>
            </label>
          </div>
        </div>
        <div class="mb-1" v-if="dadosPausa.tempo === 0">
          <label class="text-dark mb-0 small">Tempo com a loja fechada (horas)*</label>
          <input type="number" id="tempoPausa" class="form-control" v-model="dadosPausa.tempoCustomizado" min="1" step="1">
          <div class="small">Fechado por <b>{{ dadosPausa.tempoCustomizado }} hora{{dadosPausa.tempoCustomizado > 1 ? 's' : ''}}</b></div>
        </div>
        <div class="mb-3" v-if="dadosPausa.tempo !== 1440">
          <label class="text-dark mb-0 small">Motivo do fechamento*</label>
          <input type="text" id="motivoPausa" class="form-control" v-model="dadosPausa.titulo_pausa" maxlength="256" placeholder="Ex: Alta taxa de pedidos">
          <div class="small">Essa informação será exibida para seus clientes.</div>
        </div>
      </div>
      <div class="border-top p-2 text-center d-flex justify-content-between">
        <button class="btn btn-dark border p-3" @click="modalPausa = false"><i class="fa fa-angle-left mr-1"></i> Voltar</button>
        <div>
          <button class="btn btn-primary px-4 py-3" @click="toogleStatus()" :disabled="dadosPausa.tempo !== 1440 && dadosPausa.titulo_pausa.length < 6">Salvar</button>
        </div>
      </div>
    </modal>

    <div class="modal-status shadow" v-show="modalStatus">
      <div class="d-flex align-items-center status-item">
        <img src="../../assets/logo-lecard.png" style="width: 28px; margin-right: 12px; margin-left: 3px">
        <div>
          <h6 class="m-0">LeCard</h6>
          <div class="small" style="line-height: 15px">
            <div v-if="loadStatus">Aguarde..</div>
            <div v-else>
              <span v-if="empresa.titulo_pausa" :title="empresa.titulo_pausa"><b>Pausado</b> - {{ empresa.titulo_pausa }}</span>
              <span class="text-success" v-else-if="empresa.ativo === '1' && empresa.aberto === '1'">Aberto</span>
              <span v-else-if="empresa.ativo === '1' && empresa.entregas && empresa.entregas.length">Apenas pedidos agendados</span>
              <span v-else>{{empresa.ativo === '1' ? 'Fora do horário de expediente' : 'Fechado'}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-for="grupo in integracoes" :key="grupo.plataforma"
           :aria-label="'Visualizar integração ' + getNomeIntegracao(grupo.plataforma)" class="pointer d-flex align-items-center status-item" role="button"
           tabindex="0"
           @click="openIntegracao(grupo)" @mousedown.prevent
           @keydown.enter.prevent="openIntegracao(grupo)" @keydown.space.prevent="openIntegracao(grupo)">
        <img v-if="grupo.plataforma === '2'" class="logo-integracao" src="../../assets/icons/ifood.svg">
        <img v-if="grupo.plataforma === '4'" class="logo-integracao" src="../../assets/icons/uairango.svg">
        <img v-if="grupo.plataforma === '16'" class="logo-integracao" src="../../assets/icons/aiqfome.svg">
        <img v-if="grupo.plataforma === '18'" class="logo-integracao" src="../../assets/icons/99food.png">
        <div>
          <h6 class="m-0">{{ getNomeIntegracao(grupo.plataforma) }}</h6>
          <div class="small text-muted">{{ grupo.integracoes.length }} integração{{ grupo.integracoes.length > 1 ? 's' : '' }}</div>
        </div>
        <i aria-hidden="true" class="fa fa-angle-right text-primary ml-auto px-2 flex-shrink-0"></i>
      </div>
      <div class="text-center py-2">
        <button class="btn btn-gray btn-sm btn-block text-info" type="button" @click="reloadPage()" @mousedown.prevent>
          <i aria-hidden="true" class="fa fa-sync-alt mr-1"></i> Sincronizar agora
        </button>
      </div>
    </div>

    <validador-voucher/>
    <modal-notificacoes ref="modalNotificacoes"/>
    <modal-integracao ref="modalIntegracao"/>

    <modal :opened="modalEmpresas" no-pad="true">
      <div class="container-fluid px-0">
        <h6 class="font-weight-bold p-3 text-center mb-0">Trocar Loja</h6>
        <div class="mb-5" v-if="loadTempo">
          <loading/>
        </div>
        <div class="pb-2" style="max-height: calc(100vh - 190px); overflow-y: auto;" v-show="!loadTempo">
          <a href="javascript:" class="list-empresas border-top text-decoration-none" v-for="e in empresas" @click="acessarEmpresa(e)">
            <img class="bg-primary" :src="e.url_imagem || `${base_cdn}/lecard-corporativo/static/imgs/default.png`">
            <div class="text-dark">
              <h6 class="font-weight-bold mb-0">{{e.nome_fantasia}}</h6>
              <div class="small" v-if="e.isDefault"><span class="badge badge-primary">Selecionado</span></div>
              <div class="text-muted small" v-else>Clique para acessar</div>
            </div>
          </a>
        </div>
        <div class="border-top p-3 text-center">
          <button class="btn btn-dark border px-3" @click="modalEmpresas = false" :disabled="loadTempo">
            Voltar
          </button>
        </div>
      </div>
    </modal>

    <version-app :gestor="true" fixed="true" v-show="$route.name === 'Config'"/>
  </div>
</template>

<script>
  import Modal from '../gestor/ModalGestor'
  import ValidadorVoucher from "../gestor/ValidadorVoucher";
  import VersionApp from "./VersionApp";
  import Loading from "../gestor/loading";
  import ModalNotificacoes from "../notificacoes/ModalNotificacoes";
  import Tooltip from "./Tooltip";
  import ModalIntegracao from "./ModalIntegracao";

  export default {
    name: 'TopBar',
    components: {ModalIntegracao, Tooltip, ModalNotificacoes, Loading, VersionApp, ValidadorVoucher, Modal},

    data() {
      return {
        token: localStorage.getItem('key'),
        menu: false,
        showPedidos: false,
        openInNewPage: true,
        load: false,
        connected: true,
        notification: '',
        id_empresa: null,
        multiple: false,

        modalEmpresas: false,
        modalStatus: false,
        loadStatus: false,

        modalTempo: false,
        modalPausa: false,
        loadTempo: false,
        zona_edit: false,
        zona_tempo: 0,
        zona_taxa: 0,
        entrega: {
          raios: [],
          zonas: [],
          unidade_tempo: '1',
          media_retirada: '',
          tipo_delivery: '1'
        },

        dadosPausa: { tempo: 1440, tempoCustomizado: 1, titulo_pausa: '' },
        pausas: [
          { valor: 1440, nome: 'Final do dia' }, { valor: 15, nome: '15 minutos' }, { valor: 30, nome: '30 minutos' }, { valor: 45, nome: '45 minutos' }, { valor: 60, nome: '1 hora' }, { valor: 0, nome: 'Customizado' }
        ],
        deferredPrompt: null,
        loadUairango: false,

        hideFinanceiro: true,
        financeiro: {
          data_vencimento: '10/04/2024',
          dias_vencimento: 2,
          status: 0,
          url_pagamento: false
        }
      }
    },

    methods: {
      openIntegracao(grupo) {
        this.modalStatus = false;
        this.$refs.modalIntegracao.open(grupo.integracoes, this.getNomeIntegracao(grupo.plataforma));
      },
      getNomeIntegracao(plataforma) {
        const integracoes = {
          '2': 'iFood',
          '4': 'UaiRango',
          '16': 'AiqFome',
          '18': '99Food'
        };

        return integracoes[plataforma] || '';
      },

      toogleOperacao(entrega) {
        if (entrega) {
          if (this.entrega.tipo_delivery === '2') {
            this.entrega.tipo_delivery = '1';

          } else {
            this.entrega.tipo_delivery = ['1', '3'].includes(this.entrega.tipo_delivery) ? '2' : '1';
          }

        } else {
          if (this.entrega.tipo_delivery === '3') {
            this.entrega.tipo_delivery = '1';

          } else {
            this.entrega.tipo_delivery = ['1', '2'].includes(this.entrega.tipo_delivery) ? '3' : '2';
          }
        }
      },

      silenciar() {
        this.$store.commit('setBell', false);
        this.pauseNotification();
      },

      getStatusEmpresa(callback) {
        const token = localStorage.getItem('token');

        if (this.loadStatus || !token) {
          return;
        }

        this.loadStatus = true;

        this.$http.get('delivery/empresa/status/' + token)
          .then(response => {
            this.loadStatus = false;

            if (response.data) {
              this.$store.state.statusEmpresa.token = token;
              this.$store.state.statusEmpresa.aberto = response.data.aberto;
              this.$store.state.statusEmpresa.agendamento = response.data.agendamento;
              this.$store.state.statusEmpresa.ativo = response.data.ativo;
              this.$store.state.statusEmpresa.status = response.data.status;
              this.$store.state.statusEmpresa.titulo_pausa = response.data.titulo_pausa;

              if (callback) {
                callback(true);
              }

            } else {
              if (callback) callback(false);
            }

          }, res => {
            this.loadStatus = false;
            console.log(res);

            if (callback) {
              if (callback) callback(false);
            }
          });
      },

      openModalPausa() {
        this.menu = false;
        this.$store.state.load = "Por favor aguarde..";
        const ativo = this.empresa.ativo;

        this.getStatusEmpresa((res) => {
          this.$store.state.load = false;

          if (!res) {
            return;
          }

          if (ativo !== this.empresa.ativo) {
            this.$swal(`A loja já está ${this.empresa.ativo === '1' ? 'ativada' : 'desativada'}`);
            return;
          }

          if (this.empresa.ativo !== '1') {
            this.changeStatus({ status: '1' });

          } else {
            this.dadosPausa = { tempo: 1440, tempoCustomizado: 1, titulo_pausa: '' };
            this.modalPausa = true;
          }
        });
      },

      togglePausa() {
        if (this.dadosPausa.tempo === 1440) {
          this.dadosPausa.titulo_pausa = '';
          return;
        }

        this.dadosPausa.titulo_pausa = 'Alta taxa de pedidos';
        this.$nextTick(() => {
          this.$helpers.focusElement(this.dadosPausa.tempo === 0 ? 'tempoPausa' : 'motivoPausa');
        })
      },

      toogleStatus() {
        if (this.load) {
          return;
        }

        const dados = { status: '0' };

        if (this.dadosPausa.tempo !== 1440) {
          let tempo = this.dadosPausa.tempo;

          if (tempo === 0 && this.dadosPausa.tempoCustomizado > 0) {
            tempo =  Math.round(this.dadosPausa.tempoCustomizado * 60);
          }

          if (tempo <= 0) {
            this.$swal("Por favor informe por quanto tempo sua loja ficará fechada").then(() => {
              this.dadosPausa.tempo = 0;
              this.$helpers.focusElement('tempoPausa');
            });

            return;

          } else if (this.dadosPausa.titulo_pausa.trim().length < 6) {
            this.$swal("Por favor informe o motivo do fechamento da loja").then(() => {
              this.$helpers.focusElement('motivoPausa');
            });

            return;
          }

          dados.tempo_pausa = tempo;
          dados.titulo_pausa = this.dadosPausa.titulo_pausa;
        }

        let msg = this.empresas.length > 1 ? "Você está preste a fechar todas as lojas do LeCard conectadas. Deseja realmente fechar?" : null;

        if (msg) {
          this.$swal({
            text: msg,
            buttons: ["Não", "Sim"],
            dangerMode: true
          }).then((result) => {
            if (result) {
              this.changeStatus(dados);
            }
          });

        } else {
          this.changeStatus(dados);
        }
      },

      changeStatus(dados) {
        this.load = true;
        this.modalPausa = false;
        const empresas = (this.empresas || []).map(e => e.id_empresa).filter(id => !!id);
        const payload = { ...dados };

        if (empresas.length) {
          payload.empresas = empresas;
        }

        this.$http.post('v2/delivery/empresa/status/', payload)
          .then(response => {
            this.getStatusEmpresa(() => {
              this.load = false;
            });

          }, res => {
            console.log(res);
            this.load = false;
            this.modalPausa = true;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      reloadPage() {
        this.$store.state.load = "Sincronizando..";
        this.$cache.resetAll();
        window.location.reload();
      },

      openTempo() {
        if (this.multiple && !this.id_empresa) {
          this.id_empresa = this.empresas[0].id_empresa;
        }

        this.zona_tempo = 0;
        this.zona_taxa = 0;
        this.zona_edit = false;
        this.modalTempo = true;
        this.loadTempo = true;
        this.menu = false;

        this.$http.get(`entrega/config/${this.token}?id_empresa=${this.id_empresa}`)
          .then(response => {
            this.entrega = response.data || {};
            this.loadTempo = false;

            const un = this.entrega.unidade_tempo !== '1' ? (this.entrega.unidade_tempo === '2' ? 60 : 1440) : 1;
            this.entrega.media_retirada = Math.round(parseInt(this.entrega.media_retirada) / un);

            this.entrega.raios.forEach(r => {
              r.tempo_entrega = Math.round(r.tempo_entrega / un);
            });

            this.entrega.zonas.forEach(z => {
              z.taxa = z.taxa_entrega;
              z.tempo = Math.round(z.tempo_entrega / un);
              z.tempo_entrega = z.tempo;
            });

          }, res => {
            this.loadTempo = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          })
      },

      salvarTempo() {
        if (this.entrega.geo_disabled !== '2' && this.entrega.raios.find(r => !r.tempo_entrega)) {
          this.$swal("O tempo é obrigatório. Verique os raios de entrega e tente novamente.");
          return;
        }

        this.loadTempo = true;
        this.entrega.zonas = [];

        if (this.zona_edit) {
          this.entrega.zona_tempo = this.zona_tempo;
          this.entrega.zona_taxa = this.zona_taxa;
        }

        this.$http.post('entrega/config/' + this.token, this.entrega)
          .then(res => {
            this.$swal("Taxa e tempo editado com sucesso!");
            this.loadTempo = false;

            if (this.zona_edit) {
              this.openTempo();
            }

          }, res => {
            console.log(res);
            this.loadTempo = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      alterarZona() {
        this.zona_edit = true;
        this.entrega.zonas.forEach(z => {
          const tempo = parseInt(z.tempo) + parseInt(this.zona_tempo);
          const taxa = parseFloat(z.taxa) + this.zona_taxa;
          z.tempo_entrega = (tempo < 0) ? 0 : tempo;
          z.taxa_entrega = (taxa < 0) ? 0 : taxa;
        })
      },

      goPortal() {
        if (this.$route.name !== 'Portal') {
          this.$router.push('/portal');
        }
      },

      goPdv() {
        if (this.openInNewPage) {
          let url = this.$helpers.getLink('home');

          if (this.isElectron) {
            document.dispatchEvent(new CustomEvent('gopage', { detail: { url } }));

          } else {
            window.open(url, '_blank');
          }

        } else if (this.$route.name !== 'HomePdv') {
          this.$router.push('/home');
        }
      },

      goTerminal() {
        if (this.openInNewPage) {
          let url = this.$helpers.getLink('terminal');

          if (this.isElectron) {
            document.dispatchEvent(new CustomEvent('gopage', { detail: { url } }));

          } else {
            window.open(url, '_blank');
          }

        } else if (this.$route.name !== 'Terminal') {
          this.$router.push('/terminal');
        }
      },

      toggleMenuLojas() {
        this.modalStatus = !this.modalStatus;

        if (this.modalStatus) {
          this.getStatusEmpresa();
        }
      },

      goHome() {
        if (this.multiple) {
          this.modalEmpresas = true;

        } else {
          let url = !this.is_mobile && this.showPedidos ? '/pedidos' : '/home';

          if (this.$route.path !== url) {
            this.$router.push(url);
          }
        }
      },

      openChats() {
        this.$store.state.modalChat = true;
        this.$store.state.chats = [];
      },

      fecharFinanceiro() {
        this.hideFinanceiro = true;
        sessionStorage.setItem('hideFinanceiro', '1');
      },

      acessarEmpresa(e) {
        if (e.isDefault) {
          this.modalEmpresas = false;
          return;
        }

        this.modalEmpresas = false;
        this.$store.state.load = "Alterando..";
        //this.loadTempo = true;
        this.$http.post("adm/acesso/" + this.token, { id_empresa: e.id_empresa })
          .then(res => {
            //this.loadTempo = false;
            //this.modalEmpresas = false;
            //localStorage.setItem('token', e.token);
            //this.$store.state.dataUser.nome_fantasia = e.nome_fantasia;
            //this.$store.state.empresas.forEach(empresa => empresa.isDefault = (empresa.id_empresa === e.id_empresa));
            //this.$emit('reload', e);

            localStorage.setItem('token', e.token);
            this.reloadPage();

          }, res => {
            console.log(res);
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      }
    },

    computed: {
      integracoes() {
        const grupos = [];
        this.$store.state.integracoes.filter(integracao => String(integracao.fg_ativo) === '1').forEach(integracao => {
          const plataforma = String(integracao.plataforma);
          let grupo = grupos.find(item => item.plataforma === plataforma);
          if (!grupo) {
            grupo = { plataforma, integracoes: [] };
            grupos.push(grupo);
          }
          grupo.integracoes.push(integracao);
        });
        return grupos;
      },
      empresa() {
        return this.$store.state.statusEmpresa
      },

      dados() {
        return this.$store.state.dataUser
      },

      bell() {
        return this.$store.state.bell
      },

      empresas() {
        return this.$store.state.empresas
      },

      modalOflline() {
        return this.$store.state.modalOflline
      },

      canPlay() {
        return this.$store.state.canPlay
      },

      printsError() {
        return this.$store.state.printsError
      },

      isReadOnly() {
        return this.$store.state.isReadOnly;
      },

      isTerminal() {
        return this.$store.state.isTerminal;
      },

      isComanda() {
        return this.$store.state.is_comanda;
      },

      chats() {
        return this.$store.state.chats
      },

      novidades() {
        return this.$store.state.novidades;
      },

      tempo() {
        const unid = this.entrega.unidade_tempo;
        return unid === '3' ? 'dias' : (unid === '2' ? 'horas' : 'mins');
      }
    },

    sockets: {
      connect() {
        setTimeout(() => {
          this.connected = true;
          // this.$store.state.modalOflline = false;
        }, 5000);
      },

      disconnect() {
        this.connected = false;
        //this.$store.state.modalOflline = true;
      }
    },

    mounted() {
      this.showPedidos = !this.isComanda && !this.isReadOnly;
      this.openInNewPage = this.isElectron && localStorage.getItem('openInNewPage') === '1';
      this.hideFinanceiro = sessionStorage.getItem('hideFinanceiro') || !this.financeiro.status;
      this.multiple = this.empresas.length > 1;

      if (!this.empresa.token) {
        this.getStatusEmpresa();
      }

      setTimeout(() => {
        this.connected = this.$socket ? this.$socket.connected : false;
      }, 10000);
    },

    created() {
      this.$parent.$on('ativarDelivery', () => {
        this.toogleStatus();
      });

      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.deferredPrompt = e;
      });
    }
  }
</script>
<style scoped>
 .badge-notification {
   position: absolute;
   top: -7px;
   right: 8px;
   color: #fff;
   font-weight: bold;
   padding: 0 7px;
   border-radius: 40%;
   font-size: 12px;
 }

 .modal-status {
   background-color: #ffffff;
   position: fixed;
   z-index: 1900;
   top: 58px;
   right: 16px;
   width: 262px;
   border: 1px solid #dee2e6;
   border-radius: .35rem;
   padding: 0 10px;
 }

 .modal-status .status-item {
   border-bottom: 1px solid #dee2e6;
   padding: 10px 2px;
 }

 .logo-integracao {
   width: 28px;
   margin-right: 12px;
 }

 .logo-empresa {
   width: 38px;
   height: 38px;
   margin-right: 12px;
   margin-left: 2px;
   border-radius: 50%;
   object-fit: cover;
 }

 .financeiro {
   position: fixed;
   z-index: 9;
   left: 70px;
   right: 0;
   top: 61px;
   border-radius: 0!important;
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding-right: 12px;
 }

 .btn-financeiro {
   float: right;
 }

 .btn-topbar {
   white-space: nowrap;
   margin-right: 7px;
   min-width: 46px;
   position: relative;
 }

 .list-empresas {
   display: flex;
   align-items: center;
   padding: 10px 15px;
 }

 .list-empresas img {
   width: 52px;
   height: 52px;
   border-radius: 50%;
   object-fit: cover;
   margin-right: 12px;
 }

 .list-empresas:last-child {
   border-bottom: none!important;
 }

 .list-empresas:hover {
   background-color: rgba(0,0,0,0.1);
 }

 .badge-env {
   position: absolute;
   bottom: -5px;
   left: 50%;
   transform: translateX(-50%);
   font-size: 0.6rem;
 }

 @media (max-width: 767px) {
   .financeiro {
     left: 0;
     padding-left: 12px;
   }

   .badge-notification {
     right: 8px;
     top: 8px;
   }
 }
</style>
